import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { IContractProps } from "../../models";
// styles
import styles from "./styles.module.scss";

export interface Props extends IContractProps {
  backgroundColor?: string;
}

export const PaymentDetails = ({ contract, backgroundColor = "" }: Props) => {
  function createRow(desc: string, price: number) {
    return { desc, price };
  }
  const { t } = useTranslation();
  const rows = [
    createRow(
      t("lbl_contract_details_main_cost_title"),
      contract?.itemPrice || 0
    ),
    createRow(
      t("lbl_contract_details_delivery_title"),
      contract?.shipment?.fee || 0
    ),
  ];
  const invoiceTotal = contract?.itemPrice + (contract?.shipment?.fee || 0);
  return (
    <div
      style={{ backgroundColor: backgroundColor }}
      className={styles.table_container}>
      <table className={styles.table_container__section}>
        <tbody>
          {rows.map((row, index) => (
            <tr key={row.desc}>
              <td
                className={classNames(
                  styles.table_cell,
                  "hint",
                  "g800",
                  index + 1 == rows.length
                )}>
                {row.desc}
              </td>
              <td
                className={classNames(
                  styles.table_cell,
                  styles.price,
                  index + 1 == rows.length
                )}
                align="right">
                <span className={"subtitle2"}>
                  {Number(row.price).toFixed(2)}{" "}
                  <span className={classNames("p2", "g700")}>
                    {" "}
                    {t("lbl_saudi_currency")}
                  </span>
                </span>
              </td>
            </tr>
          ))}
          <div className={styles.divider} />
          <tr>
            <td style={{ paddingBottom: 0 }}>
              <span className={"subtitle1"}>{t("lbl_total")}</span>
            </td>
            <td
              style={{ paddingBottom: 0 }}
              className={classNames("subtitle1")}
              align="right">
              <span className={"subtitle1"}>
                {Number(invoiceTotal).toFixed(2)}{" "}
                <span className={classNames("subtitle1", "g700")}>
                  {t("lbl_saudi_currency")}
                </span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
